// extracted by mini-css-extract-plugin
module.exports = {"heading":"ContactPage_heading__eMcL9","content":"ContactPage_content__3artj","logo":"ContactPage_logo__3cCBm"};